import { TOOL_TEMPLATE } from "../constant/common";
import { store } from "./index";
import {
  currenciesSettingIndexerSelector,
  templateSettingsSelector,
  companySettingsSelector,
  companyExternalSettingsSelector,
  instrumentSettingsIndexer,
  formatSettingIndexerSelector
} from "./slice/settings/selectors";

export const getCurrencyLabel = currencyCode => {
  const indexer = currenciesSettingIndexerSelector(store.getState());

  const result = indexer[currencyCode];

  if (!result) return currencyCode;

  return result;
};

export const renderTextBasedOnTemplate = (quadrataText, victorText) => {
  const template = templateSettingsSelector(store.getState());

  switch (template) {
    case TOOL_TEMPLATE.quadrata:
      return quadrataText;
    case TOOL_TEMPLATE.victor:
      return victorText;
    default:
      break;
  }
  return "";
};

export const isUseLatinNumber = () => companySettingsSelector(store.getState()).useLatinNumber;

export const getTickerPatternById = id => companyExternalSettingsSelector(store.getState()).tickerPattern[id];

export const getInstrumentSettings = instrumentId => {
  const instrumentSettings = instrumentSettingsIndexer(store.getState());
  const result = instrumentSettings[instrumentId];

  if (!result) return {};

  return result;
}

export const getFormatSetting = () => {
 return formatSettingIndexerSelector(store.getState());
}